import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import LoadingProgress from 'common/components/progress/loading';
import NewSelectMultiple from 'common/components/fields/NewSelectMultiple';
import { create_or_update, setFormValue } from 'helpers/formComponent';
import React, { useEffect } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { getStationActiveActions } from '../activeActions/activeActionsScripts';
import {
  create,
  getDetail,
  initializeForm,
  setDetail,
  setLoading,
  update,
} from './validatorsActions';

let ValidatorCodeForm = function (props) {
  const { validatorCode, router, location, getDetail, setDetail, activeActions } = props;
  const { id } = props.auth.user.establishments[0].stations[0];
  const opcoesActions = activeActions.list.map((it) => ({ id: it.id, title: it.name }));
  const hasSelectedActions = props.formValues?.actions?.length > 0;

  useEffect(() => {
    if (!router.params.id) {
      props.setLoading(false);
    } else {
      setFormValue(validatorCode, router, location, getDetail, setDetail);
    }
    if (_.isEmpty(props.activeActions.list)) {
      props.getStationActiveActions(id);
    }
  }, []);

  function onSubmit(values) {
    const { create, update } = props;

    const actions = values.actions || [];

    const newValues = {
      ...values,
      actions,
      station_id: props.auth.user.establishments?.[0]?.stations?.[0]?.id,
    };

    create_or_update(router, newValues, create, update);
  }

  const arrayTypes = [
    { label: 'Grid 2x3 (modelo original)', value: 1 },
    { label: 'Grid texto-imagem verticalizado', value: 2 },
    { label: 'Carousel', value: 3 },
    { label: 'Centralizado com imagem embaixo', value: 4 },
    { label: 'Atividades em Destaque', value: 5 },
    { label: 'Planos', value: 7 },
  ];

  if (props.auth.user.establishments[0].stations[0].has_app) {
    arrayTypes.push({ label: 'Baixar o app', value: 6 });
  }

  return props.validatorCode.loading ? (
    <Box display="flex" height="100vh" justifyContent="center" mt={10}>
      <LoadingProgress />
    </Box>
  ) : (
    <section id="validatorCode-form" style={{ paddingBottom: isMobileOnly ? 100 : 0 }}>
      <GeneralGrid container spacing={3}>
        <GeneralGrid item xs={12}>
          <div className="card">
            <div className="card-body">
              <h4 className="h4 card-title text-muted">Validadores</h4>

              <GeneralGrid item xs={12} style={{ marginTop: '16px' }}>
                <Alert
                  severity={hasSelectedActions ? 'info' : 'warning'}
                  style={{ marginBottom: '16px' }}>
                  {hasSelectedActions
                    ? 'Apenas as atividades selecionadas poderão ser validadas por este validador.'
                    : 'Caso nenhuma atividade seja selecionada, o validador estará apto a validar qualquer atividade da estação.'}
                </Alert>
              </GeneralGrid>
              <Form role="form" onSubmit={props.handleSubmit(onSubmit)} noValidate>
                <GeneralGrid container spacing={3}>
                  <GeneralGrid item xs={12}>
                    <Field
                      component={InputLabelOutlined}
                      label="Identificação (nome, matrícula, ID)"
                      name="identification"
                      required
                      margin="normal"
                    />
                  </GeneralGrid>
                </GeneralGrid>
                <GeneralGrid container item xs={12} md={6} spacing={3}>
                  <GeneralGrid item xs={12}>
                    <Field
                      component={InputLabelOutlined}
                      label="Código"
                      name="code"
                      required
                      margin="normal"
                    />
                  </GeneralGrid>
                </GeneralGrid>

                <GeneralGrid container spacing={3}>
                  <GeneralGrid item xs={12}>
                    <Field
                      component={NewSelectMultiple}
                      label={'Selecione as atividades'}
                      options={opcoesActions}
                      name="actions"
                      margin="normal"
                    />
                  </GeneralGrid>
                </GeneralGrid>
                <GeneralGrid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  style={{ marginTop: 32 }}>
                  <SecondaryButton
                    onClick={() => props.router.push('/owner/validadores')}
                    color="primary">
                    Cancelar
                  </SecondaryButton>
                  <PrimaryButton
                    type="submit"
                    disabled={props.validatorCode.buttonLoading}
                    progress={parseInt(props.general.submitProgress)}>
                    {props.validatorCode.buttonLoading ? 'Salvando' : 'Salvar'}
                  </PrimaryButton>
                </GeneralGrid>
              </Form>
            </div>
          </div>
        </GeneralGrid>
      </GeneralGrid>
    </section>
  );
};

ValidatorCodeForm.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
    }),
  }),
  change: PropTypes.func,
  create: PropTypes.any,
  general: PropTypes.shape({
    submitProgress: PropTypes.any,
  }),
  getDetail: PropTypes.any,
  handleSubmit: PropTypes.func,
  location: PropTypes.any,
  router: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.any,
    }),
  }),
  setDetail: PropTypes.any,
  setLoading: PropTypes.func,
  update: PropTypes.any,
  validatorCode: PropTypes.shape({
    buttonLoading: PropTypes.any,
    loading: PropTypes.any,
  }),
};

ValidatorCodeForm = reduxForm({ form: 'validatorCodeForm' })(ValidatorCodeForm);

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    validatorCode: state.validatorCode,
    activeActions: state.activeActions,
    formValues: getFormValues('validatorCodeForm')(state),
    general: state.general,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getDetail,
      setDetail,
      initializeForm,
      create,
      update,
      getStationActiveActions,
      setLoading,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidatorCodeForm);
